export function formatDisplay(
  value: number,
  opts: Partial<{
    disableSmallValue?: boolean;
    decimalToShow: number;
    locale: string;
    minimumDecimalToShow?: number;
    disable: boolean;
  }>,
  firstSynbol?: string
): string {
  if (isNaN(value)) {
    return "0";
  }

  const decimalToShow = opts.decimalToShow ?? 5;
  const op = {
    maximumFractionDigits: decimalToShow,
    minimumFractionDigits: opts?.minimumDecimalToShow ?? 0,
    roundingMode: "floor" as const,
  };
  const formatter = new Intl.NumberFormat(opts.locale || "en-US", op);

  if (opts.disable) {
    return formatter.format(value);
  }

  if (!opts.disableSmallValue && Math.abs(value) < Math.pow(10, -decimalToShow) && value > 0) {
    return `< ${firstSynbol || ""}${formatter.format(Math.pow(10, -decimalToShow))}`;
  }

  return `${firstSynbol || ""}${formatter.format(value)}`;
}

export const numberFormat = (number: number, decimalToShow?: number) => {
  const formatter = Intl.NumberFormat("en-US", {
    maximumFractionDigits: decimalToShow || decimalToShow === 0 ? decimalToShow : 2,
    minimumFractionDigits: 0,
  });

  return formatter.format(number);
};

export function formatNumberBalance(number: number) {
  if (number >= 1e9) {
    return numberFormat(number / 1e6, 2) + "B";
  }
  if (number >= 1e6) {
    return numberFormat(number / 1e6, 2) + "M";
  }
  if (number >= 1e3) {
    return numberFormat(number / 1e3, 2) + "K";
  }
  return numberFormat(number, 3);
}

export function formatNumber(number: number) {
  if (number >= 1e9) {
    return {
      value: Math.floor(number / 1e9),
      value2: Math.floor(Number(((number / 1e9) % Math.floor(number / 1e9)) * 100)),
      text: "B",
    };
  }
  if (number >= 1e6) {
    return {
      value: Math.floor(number / 1e6),
      value2: Math.floor(Number(((number / 1e6) % Math.floor(number / 1e6)) * 100)),
      text: "M",
    };
  }

  if (number >= 1e3) {
    return {
      value: Math.floor(number / 1e3),
      value2: Math.floor(Number(((number / 1e3) % Math.floor(number / 1e3)) * 100)),
      text: "K",
    };
  }

  return {
    value: Math.floor(number),
    value2: Math.floor(Number((number % Math.floor(number)) * 10)),
    text: "",
  };
}
